import { ArrowLeftThin, ArrowRightThin } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import get from 'lodash.get';
import { useState, useCallback } from 'react';
import { CAROUSEL_NEXT_ARROW, CAROUSEL_PREVIOUS_ARROW } from '../../common';
import { NextArrow, PreviousArrow } from './styles';
import { shouldShowNextArrow, shouldShowPreviousArrow, getIndex } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const NavigationArrows = ({
  instanceRef,
  lastSlideVisible,
  slider,
  slidesCount,
  navigation
}) => {
  const {
    getTestId
  } = useTestId();
  const [isAtTheEnd, setIsAtTheEnd] = useState(false);
  const [isAtTheStart, setIsAtTheStart] = useState(true);
  const currentSlide = get(instanceRef, 'current.track.details.rel', 0);
  const createHandler = useCallback(type => event => {
    event.stopPropagation();
    const index = getIndex({
      instanceRef,
      isAtTheEnd,
      isAtTheStart,
      setIsAtTheEnd,
      setIsAtTheStart,
      slider,
      slidesCount,
      type
    });
    instanceRef.current?.moveToIdx(index);
  }, [instanceRef, isAtTheEnd, isAtTheStart, slider, slidesCount]);
  const onNextClick = createHandler('next');
  const onPreviousClick = createHandler('previous');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldShowPreviousArrow({
      currentSlide,
      slider
    }) ? /*#__PURE__*/_jsx(PreviousArrow, {
      "aria-label": "\u2190",
      "data-testid": getTestId(CAROUSEL_PREVIOUS_ARROW),
      height: navigation?.height,
      size: navigation?.size,
      onClick: onPreviousClick,
      children: /*#__PURE__*/_jsx(ArrowLeftThin, {})
    }) : null, shouldShowNextArrow({
      lastSlideVisible,
      slidesCount,
      currentSlide,
      slider
    }) ? /*#__PURE__*/_jsx(NextArrow, {
      "aria-label": "\u2192",
      "data-testid": getTestId(CAROUSEL_NEXT_ARROW),
      height: navigation?.height,
      size: navigation?.size,
      onClick: onNextClick,
      children: /*#__PURE__*/_jsx(ArrowRightThin, {})
    }) : null]
  });
};
//# sourceMappingURL=NavigationArrows.js.map